import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import * as R from 'ramda';
import { Subject } from 'rxjs';

import { ComponentStyle } from '../../../models';
import { PreventDefault } from '../../../util';
import { AccordionPanelConfig } from './accordion-panel-config';

@Component({
  selector: 'pcs-accordion-panel',
  styleUrls: ['./accordion-panel.component.scss'],
  templateUrl: './accordion-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionPanelComponent implements OnChanges {
  @Input() config: AccordionPanelConfig = new AccordionPanelConfig();
  @Input() set expanded(value: boolean) {
    this.isOpen = value;
    this._expanded = value;

    if (this.isOpen) {
      this.panelState.next(this);
    }
  }

  @Output() toggled = new EventEmitter<boolean>();

  isOpen: boolean;
  disabled: boolean;
  style: ComponentStyle;
  tabIndex = null;
  panelState = new Subject<AccordionPanelComponent>();
  panelState$ = this.panelState.asObservable();

  get expanded(): boolean {
    return this._expanded;
  }

  private _expanded = null;

  ngOnChanges(changes: SimpleChanges): void {
    const configChanges = changes.config;
    if (configChanges && !R.equals(configChanges.previousValue, configChanges.currentValue)) {
      this.isOpen = this.isControlled() ? this.expanded : this.config.isOpen;
      this.disabled = this.config.disabled;
      this.style = this.config.style;
      this.tabIndex = this.disabled ? '-1' : null;
    }
  }

  toggle() {
    if (this.isControlled()) {
      this.toggled.emit(!this.expanded);
    } else {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.panelState.next(this);
      }
      this.toggled.emit(this.isOpen);
    }
  }

  @PreventDefault()
  onClick(event: Event) {
    if (!this.disabled) {
      this.toggle();
    }
  }

  private isControlled(): boolean {
    return this.expanded !== null;
  }
}
